import React from "react";

import FormFactory from "../../../../components/form/form-factory";

import * as S from "./styles";

import IProps from "./props";

const DevNewPassword = ({
  onSubmit,
  dataForm,
  errorMessage,
}: IProps): JSX.Element => (
  <S.Container>
    <S.Title>Altere sua senha temporária</S.Title>
    <S.SubTitle>Digite sua nova senha e confirme para alterá-la</S.SubTitle>
    <FormFactory
      data={dataForm}
      onSubmit={onSubmit}
      submitErrorMessage={errorMessage}
    />
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);
export default DevNewPassword;
